import { FC, ReactNode } from 'react';
import styled from 'styled-components';

import { LinkOther } from 'atoms/navigation/Box';
import { CardImg } from 'components/card/CardImg';

const Picture = styled.div`
  position: relative;
  width: 100%;
  transition: transform 200ms ease-in-out;
`;

const Card = styled(LinkOther)`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--unit);
  width: 100%;
  &:not(:disabled) {
    &:hover,
    &:focus {
      & ${Picture} {
        transform: scale(1.05);
      }
    }
  }
`;

const CardFooter = styled.footer`
  display: flex;
  align-items: center;
  gap: var(--half-unit);
`;

const PlayerPicture = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: var(--card-aspect-ratio);
  & img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const TopBadge = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  transform: translateY(-50%);
`;
const BottomBadge = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  transform: translateY(25%);
`;

type Props = {
  CaptainWrapper: FC<{
    children: React.JSX.Element;
    captain?: boolean;
  }>;
  disabled?: boolean;
  onClick?: () => void;
  pictureUrl: string;
  captain?: boolean;
  score?: ReactNode;
  topBadge?: ReactNode;
  bottomBadge?: ReactNode;
};

export const PlayerCard = ({
  CaptainWrapper,
  captain,
  pictureUrl,
  disabled,
  onClick,
  topBadge,
  bottomBadge,
  score,
}: Props) => {
  return (
    <Card
      as="button"
      onClick={onClick}
      type="button"
      disabled={!onClick || disabled}
    >
      <CaptainWrapper captain={captain}>
        <Picture>
          <PlayerPicture>
            {pictureUrl && <CardImg src={pictureUrl} alt="" width={160} />}
          </PlayerPicture>
          {topBadge && <TopBadge>{topBadge}</TopBadge>}
          {bottomBadge && <BottomBadge>{bottomBadge}</BottomBadge>}
        </Picture>
      </CaptainWrapper>
      <CardFooter>{score}</CardFooter>
    </Card>
  );
};
